import styled from 'styled-components';
import { FormTitleStyles } from 'components/Form/styles';

export const OtherIndustryContainer = styled.div`
  padding: 40px;
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${(props) =>
    !props.isSingleStepForm &&
    `
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  `}

  @media (max-width: 767px) {
    padding: 24px 16px 0;
  }
  @media (max-width: 575px) {
    height: 100%;
    padding: 20px;
  }

  ${(props) =>
    !props.isSingleStepForm &&
    props.visible &&
    `
    visibility: visible;
    opacity: 1;
  `};

  .signup-form--other-industry-header {
    position: relative;

    .slick-prev {
      z-index: 1;
      padding: 0;
      left: 5px;
      top: 15px;
      &:before {
        border: solid black;
        border-width: 0 3px 3px 0;
        display: inline-block;
        padding: 7px;
        content: '';
        transform: rotate(135deg);
        -webkit-transform: rotate(135deg);
        opacity: 1;
      }
    }

    .signup-form--title {
      ${FormTitleStyles}
      font-size: var(--font-size-h3);
      ${(props) =>
        props.isSingleStepForm &&
        `
        letter-spacing: var(--letter-spacing--0-04);
      `}

      @media (max-width: 767px) {
        font-size: var(--font-size-25);
        ${(props) =>
          props.isSingleStepForm &&
          `
          letter-spacing: var(--letter-spacing--0-04);
        `}
      }
      @media (max-width: 575px) {
        ${(props) =>
          props.isSingleStepForm
            ? `
          font-size: 23px;
          text-align: left;
          padding: 0;
          letter-spacing: var(--letter-spacing--0-04);
        `
            : `
          font-size: var(--font-size-20);
        `}
      }
    }
  }
  @media (max-width: 575px) {
    &.modal-other-industry {
      .signup-form--title {
        padding-top: 42px;
      }
    }
  }

  .signup-form--other-industry-radio {
    height: 457px;
    max-height: 457px;
    position: relative;
    overflow: hidden;
    width: calc(100% + 25px);

    @media (max-width: 575px) {
      width: calc(100% + 18px);
      height: 100%;
      max-height: none;
      margin-bottom: 10px;
    }

    .radio-field-wrapper {
      margin: 0;
      width: 100%;
      height: 457px;
      overflow: overlay;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      display: flex;
      flex-direction: column;

      .radio-div {
        margin: 5px 0;
        ${(props) =>
          props.isSingleStepForm
            ? `
          max-width: calc(100% - 25px);
        `
            : `
          max-width: calc(100% - 10px);
        `}
        width: 100%;
        max-height: 40px;
        min-height: 40px;

        @media (max-width: 575px) {
          max-width: calc(100% - 18px);
        }

        label {
          font-family: var(--font-family);
          font-size: var(--font-size-20);
          ${(props) =>
            props.isSingleStepForm
              ? `
            font-weight: var(--font-weight-400);
            border: 1px solid var(--darkest);
          `
              : `
            font-weight: var(--font-weight-500);
            border: 1px solid var(--grey-4);
          `}
          line-height: var(--line-height-150);
          padding: 0;
          height: 100%;
          border-radius: 0;
          color: var(--darkest);

          @media (max-width: 767px) {
            ${(props) =>
              props.isSingleStepForm &&
              `
              font-size: 17px !important;
            `}
          }

          @media (max-width: 575px) {
            ${(props) =>
              !props.isSingleStepForm &&
              `
              font-size: var(--font-size-16);
            `}
          }
        }
      }
    }
  }

  .signup-form--other-industry-search {
    margin: 25px 0 9px;
    width: 100%;
    height: 58px;
    position: relative;
    border: 1px solid #d9d9d9;

    input {
      font-family: var(--font-family);
      font-weight: var(--font-weight-500);
      line-height: var(--line-height-150);
      ${(props) =>
        props.isSingleStepForm
          ? `
        font-size: var(--font-size-16);
        padding: 0 24px;
        height: 56px;
      `
          : `
        font-size: var(--font-size-20);
        padding: 14px 18px;
      `}
      color: var(--darkest);

      &::placeholder {
        ${(props) =>
          props.isSingleStepForm
            ? `
          color: var(--grey-4);
        `
            : `
          color: var(--grey-6);
        `}
      }

      @media (max-width: 575px) {
        ${(props) =>
          !props.isSingleStepForm &&
          `
          font-size: var(--font-size-18);
        `}
      }
    }

    .signup-form--other-industry-close {
      width: 34px;
      height: 34px;
      position: absolute;
      right: 8px;
      top: 12px;
      padding: 12px;
      cursor: pointer;
    }
  }
`;
